import { useEffect } from 'react';
import { Box } from '@mui/material';
import attachmentEngine from './AttachmentEngine';
import attachmentStripHandler from './AttachmentStripHandler';
import { useAttachments } from './useAttachments';
import AttachmentStripBar from './AttachmentStripBar';
import AttachmentStripThumbs from './AttachmentStripThumbs';
import UploadAttachmentDialog from './UploadAttachmentDialog';
import './AttachmentStrip.css';

// Mock providers — replaced by real settings/engine data later
const MOCK_PROVIDERS = ['Jerny Shared - R2', 'Cloudflare R2 — mijn bucket', 'Local storage (dev)'];

/**
 * AttachmentStrip — orchestrates document attachments per journal entry.
 * All UI state (collapsed, showUpload) lives in AttachmentStripHandler.
 * @param {object} props
 * @param {object} props.entry - current selected journal entry
 * @param {Function} props.onLightBox - fn(documents, index) called when thumbnail clicked
 * @param {string} [props.panelId='default'] - unique panel id, isolates engine state per panel
 */
export default function AttachmentStrip({ entry, onLightBox, panelId = 'default' }) {
    // Notify engine when selected entry changes — scoped to this panel
    useEffect(() => {
        attachmentStripHandler.init();
        attachmentEngine.setEntry(entry?.rk ?? null, panelId);
    }, [entry?.rk, panelId]);

    const { documents, collapsed, showUpload } = useAttachments(panelId);

    if (!entry) return null;

    return (
        <Box id="attachment-strip-root" className="attachment-strip-root">
            <AttachmentStripBar count={documents.length} collapsed={collapsed} />
            {!collapsed && <AttachmentStripThumbs documents={documents} onLightBox={onLightBox} />}

            <UploadAttachmentDialog
                jid={entry.rk}
                open={showUpload}
                onClose={attachmentStripHandler.handleCloseUpload}
                providers={MOCK_PROVIDERS}
            />
        </Box>
    );
}
